module.exports = __webpack_public_path__ + "static/durability-9c284bad62f5723e55b90d182b71f03e.png";